<div class="tile-separator">
    <span class="tile-separator__label">{{ label() | translate }}</span>
</div>
